var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c("template", { slot: "header" }, [
        _c("h1", [_vm._v("Assume Identity")]),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filters" },
        [
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.filters.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "sectors", $$v)
              },
              expression: "filters.sectors",
            },
          }),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: { name: "member", placeholder: "Select..." },
            model: {
              value: _vm.filters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "member", $$v)
              },
              expression: "filters.member",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.filters.query,
            expression: "filters.query",
          },
        ],
        staticClass: "form__control",
        attrs: {
          slot: "search",
          type: "search",
          placeholder: "Search Users...",
        },
        domProps: { value: _vm.filters.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.filters, "query", $event.target.value)
          },
        },
        slot: "search",
      }),
      _vm._v(" "),
      _c("ListUsers", {
        ref: "all",
        attrs: { filters: _vm.filters, "show-impersonate": true },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }